<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Operasi" :toReset="(url) => this.reset(url)" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <IntroOperasi
            :detailTop="introRalanOperasi.introRalan"
            :detailBottom="introRalanOperasi.introOperasi"
            :steps="steps"
          />
          <!--form action="/ranap/save" method="POST" enctype="multipart/form-data"-->
          <h4 class="my-4">Laporan Operasi</h4>
          <div class="row mb-2">
            <div class="col-md-12">
              <FormRow
                v-for="row in upperForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <hr />
          <div class="row mb-5">
            <div class="col-md-6">
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-6">
              <FormRow
                v-for="row in rightForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="saveAndContinue"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  SIMPAN DAN LANJUTKAN
                </button>
                <button
                  class="btn btn-outline-secondary float-right text-uppercase"
                  @click="save"
                >
                  SIMPAN
                </button>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import IntroOperasi from "@/components/IntroOperasi.vue";
import Alert from "@/components/Alert.vue";
import { setOperationIntro, resetForms } from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import { upperForm, leftForm, rightForm } from "@/data/OperasiFormLaporan.js";
import { dataOperasi } from "@/data/OperasiForm.js";
export default {
  name: "OperasiFormLaporan",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Alert,
    IntroOperasi,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: dataOperasi,
      detailTop: null,
      upperForm: upperForm,
      leftForm: leftForm,
      rightForm: rightForm,
      operasiLaporan: null,
      introRalanOperasi: { introRalan: {}, introOperasi: [] },
      steps: [],
      ralan: {},
      operasi: {},
      id_laporan: null,
      formSet: {
        id_operasi: null,
        durasi: null,
        id_operasi_ruangan: 1,
        id_dokter_operator: 0,
        id_dokter_anestesi: null,
        // id_dokter_referal: null,
        id_perawat_instrumen: null,
        id_perawat_anestesi: null,
        id_perawat_sirkuler_1: 0,
        id_perawat_sirkuler_2: 0,
        id_perawat_sirkuler_3: 0,
        id_perawat_sirkuler_4: 0,
        id_perawat_sirkuler_5: 0,
        diagnosa_pra_operasi: null,
        diagnosa_post_operasi: null,
        komplikasi: null,
        jumlah_pendarahan: null,
        jaringan_PA: null,
        asal_jaringan: null,
        time_start: "",
        time_end: "",
        kategori_tindakan: "",
        golongan_tindakan: "",
        jenis_anastesi: "",
        implant: "",
      },
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    save: async function() {
      this.handleForm();
    },
    continue: function() {
      this.$router.push(
        `/operasi/form-tindakan/${this.$route.params.id_ralan}/${this.$route.params.id}`
      );
    },
    saveAndContinue: async function() {
      this.handleForm(this.continue);
    },
    handleForm: async function(callback) {
      this.errors = [];
      let formData = new FormData();
      let body = "";
      var self = this;
      //console.log(this.formSet);
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          //console.log("==================formdata========");
          //console.log(key);
          //console.log(self.formSet[key]);
          //console.log("==================formdata========");
          if (
            key == "id_perawat_sirkuler_4" ||
            key == "id_perawat_sirkuler_5"
          ) {
            if (self.formSet[key]) {
              if (
                key == "id_perawat_sirkuler_5" &&
                self.formSet["id_perawat_sirkuler_5"] &&
                !self.formSet["id_perawat_sirkuler_4"]
              ) {
                formData.append("id_perawat_sirkuler_4", self.formSet[key]);
                body += `id_perawat_sirkuler_4=${self.formSet[key]}&`;
              } else {
                formData.append(key, self.formSet[key]);
                body += `${key}=${self.formSet[key]}&`;
              }
            }
          } else {
            formData.append(key, self.formSet[key]);
            body += `${key}=${self.formSet[key]}&`;
          }
        });
        try {
          let result;
          //console.log('Id Laporan: '+this.id_laporan);
          if (this.id_laporan) {
            result = await this.$store.state.HTTP_ENC.put(
              "operasi_laporan/" + this.id_laporan,
              body
            );
          } else {
            result = await this.$store.state.HTTP.post(
              "operasi_laporan",
              formData
            );
          }
          //console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              // that.$router.push(`/ralan/detail/${that.$route.params.id}`);
              that.reset("", true);
              if (callback) {
                callback();
              }
            }, 1000);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
      }
    },
    reset(url, stay) {
      //console.log('masuk ke reset');
      // if (this.validated) {
      resetForms(
        this.formSet,
        [this.upperForm, this.leftForm, this.rightForm],
        true,
        this.handleChange
      );
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (this.fromUrl && fromTab) {
          let queryString = "?tab=" + fromTab;
          ////console.log(backBtn)
          this.$router.push({ path: backBtn + queryString });
        } else {
          ////console.log(window.history);
          if (backBtn) {
            this.$router.push({ path: backBtn });
          } else {
            this.$router.go(-1);
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        //console.log("====================onchange===========");
        //console.log(e.target.name);
        //console.log(e.target.value);
        //console.log("====================onchange===========");
        let oldValue = this.formSet[e.target.name];
        this.formSet[e.target.name] = e.target.value;
        if (e.target.name == "time_start" || e.target.name == "time_end") {
          if (
            this.formSet["time_end"] != "" &&
            this.formSet["time_start"] != "" &&
            this.formSet["time_end"] < this.formSet["time_start"]
          ) {
            this.formSet[e.target.name] = oldValue;
            alert("Jam selesai harus lebih dari jam mulai");
            this.updateForm();
          } else {
            var start = new Date("1970-01-01T" + this.formSet["time_start"]);
            var end = new Date("1970-01-01T" + this.formSet["time_end"]);
            //console.log(start);
            //console.log(end);
            // Find the difference in milliseconds
            var diff = end.getTime() - start.getTime();
            //console.log(diff);
            // Convert the difference to minutes
            var minutes = diff / 1000 / 60;
            this.formSet["durasi"] = minutes;
            this.updateForm();
            //console.log(this.formSet["durasi"]);
            // //console.log(this.formSet['time_end'] +  this.formSet['time_start']);
          }
        } else {
          this.formSet[e.target.name] = e.target.value;
        }
      }
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      let forms = [this.upperForm, this.leftForm, this.rightForm].map(function(
        form
      ) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              column.error = "";
            }
            if (self.formSet[column.name]) {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.leftForm = forms[1];
      this.rightForm = forms[2];
      return valid;
    },
    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter?per_page=9999999999"
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log(result.data);
          let doctors = result.data.data;
          //console.log(doctors);
          this.leftForm[0].columns[0].options = doctors.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
          this.leftForm[1].columns[0].options = this.leftForm[0].columns[0].options;
          // this.leftForm[2].columns[0].options =
          //   this.leftForm[0].columns[0].options;
        } else {
          this.displayNotFoundError();
        }
        // this.fetchNurses();
      } catch (e) {
        //console.log(e);
      }
    },
    fetchData: async function() {
      let result = await this.$store.state.HTTP.get(
        `operasi_laporan?id_operasi=${this.$route.params.id}`
      );
      //console.log(result);
      //console.log(result.data);
      //console.log(result.data.data);

      if (result.data.data.length) {
        this.id_laporan = result.data.data[0].id;
        let self = this;
        let result2 = await this.$store.state.HTTP.get(
          `operasi_laporan/${this.id_laporan}`
        );
        //console.log(result2);
        this.operasiLaporan = result2.data;
        Object.keys(this.formSet).forEach(function(key) {
          // if(!(key=='id_perawat_sirkuler_1'||key=='id_perawat_sirkuler_2'||key=='id_perawat_sirkuler_3'||key=='id_perawat_sirkuler_4'||key=='id_perawat_sirkuler_5')){
          // }
          self.formSet[key] = self.operasiLaporan[key];
        });
        //console.log(self.formSet);
        //console.log(this.operasiLaporan.operasi_laporan_perawat_sirkuler);
        // this.operasiLaporan.operasi_laporan_perawat_sirkuler.forEach(function(item,index){
        //   self.formSet[`id_perawat_sirkuler[${index}]`]=item.id_perawat;
        // });
        this.updateForm();
      }
    },
    updateForm() {
      let self = this;
      let forms = [this.upperForm, this.leftForm, this.rightForm].map(function(
        form
      ) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (self.formSet[column.name]) {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.leftForm = forms[1];
      this.rightForm = forms[2];
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        //console.log(result);
        if (result.status == "200") {
          this.leftForm[3].columns[0].options = result.data.data.map((item) => {
            return { value: item.id, label: item.nama };
          });
          this.leftForm[2].columns[0].options = this.leftForm[3].columns[0].options;
          this.leftForm[4].columns[0].options = this.leftForm[3].columns[0].options;
          this.leftForm[5].columns[0].options = this.leftForm[3].columns[0].options;
          this.leftForm[6].columns[0].options = this.leftForm[3].columns[0].options;
          this.leftForm[7].columns[0].options = this.leftForm[3].columns[0].options;
          this.leftForm[8].columns[0].options = this.leftForm[3].columns[0].options;
          // this.leftForm[9].columns[0].options =
          //   this.leftForm[3].columns[0].options;
        } else {
          this.displayNotFoundError();
        }
        // this.fetchData();
      } catch (e) {
        //console.log(e);
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.data.toReset = (url) => this.reset(url);
    this.formSet["id_operasi"] = this.$route.params.id;
    this.steps = [
      {
        link: `/operasi/form-laporan/${this.$route.params.id_ralan}/${this.$route.params.id}`,
        label: "Laporan Operasi",
        active: true,
      },
      {
        link: `/operasi/form-tindakan/${this.$route.params.id_ralan}/${this.$route.params.id}`,
        label: "Tindakan Operasi",
      },
      {
        link: `/operasi/form-obat/${this.$route.params.id_ralan}/${this.$route.params.id}`,
        label: "Obat dan Alat Kesehatan",
      },
      {
        link: `/operasi/form-biaya/${this.$route.params.id_ralan}/${this.$route.params.id}`,
        label: "Detail Biaya",
      },
    ];
    try {
      let result = await this.$store.state.HTTP.get(
        `operasi/${this.$route.params.id}`
      );
      //console.log(result);
      if (result.status == 200) {
        this.operasi = result.data;
        this.formSet["id_dokter_operator"] = this.operasi.id_dokter_operator;
        this.updateForm();
        let result2 = await this.$store.state.HTTP.get(
          `ralan/${this.operasi.id_ralan}`
        );
        this.ralan = result2.data;
        this.introRalanOperasi = setOperationIntro(this.ralan, this.operasi);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
    await this.fetchDoctors();
    await this.fetchNurses();
    await this.fetchData();
  },
};
</script>
